import React from "react";
import CurrencyFormat from "react-currency-format";
import { AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";

const Table = ({ coins }) => {
  return (
    <table>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Price</th>
        <th>Change 24h</th>
        <th>Change 7d</th>
        <th>Market cap</th>
        <th>24h Volume</th>
      </tr>
      {coins.map((coin, index) => (
        <tr>
          <td>{index + 1}</td>
          <td style={{ display: "flex" }}>
            <img
              style={{ marginRight: "6px" }}
              src={coin.logo}
              width="25"
              height="25"
              alt=""
            />{" "}
            {coin.name} {coin.symbol}
          </td>
          <td style={{ color: "lightgreen" }}>
            <CurrencyFormat
              value={coin.quotes[0].price}
              decimalScale={2}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </td>
          <td
            style={{
              color: coin.quotes[0].percentChange24h > 0 ? "lightgreen" : "red",
            }}
          >
            {coin.quotes[0].percentChange24h > 0 ? (
              <AiFillCaretUp />
            ) : (
              <AiFillCaretDown />
            )}
            <CurrencyFormat
              value={coin.quotes[0].percentChange24h}
              decimalScale={1}
              displayType={"text"}
              thousandSeparator={true}
            />
          </td>
          <td
            style={{
              color: coin.quotes[0].percentChange7d > 0 ? "lightgreen" : "red",
            }}
          >
            {coin.quotes[0].percentChange7d > 0 ? (
              <AiFillCaretUp />
            ) : (
              <AiFillCaretDown />
            )}
            <CurrencyFormat
              value={coin.quotes[0].percentChange7d}
              decimalScale={2}
              displayType={"text"}
              thousandSeparator={true}
            />
          </td>
          <td>
            <CurrencyFormat
              value={coin.quotes[0].marketCap}
              decimalScale={2}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </td>
          <td>
            <CurrencyFormat
              value={coin.quotes[0].volume24h}
              decimalScale={2}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </td>
        </tr>
      ))}
    </table>
  );
};

export default Table;
